// holds the data of a path
export class Metroline {
    constructor(polyline, width, sourceAndTargetLoosePolys, index) {
        this.Width = width;
        this.Polyline = polyline;
        this.sourceAndTargetLoosePolylines = sourceAndTargetLoosePolys;
        this.Index = index;
    }
    UpdateLengths() {
        let l = 0;
        for (let p = this.Polyline.startPoint; p.next != null; p = p.next) {
            l += p.next.point.sub(p.point).length;
        }
        this.Length = l;
        this.IdealLength = this.Polyline.end.sub(this.Polyline.start).length;
    }
}
//# sourceMappingURL=MetroLine.js.map